import { RootState } from '@/app/store.ts';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface TutorialSliceState {
  runTour: boolean;
  stepIndex: number;
}

const INITIAL_STATE: TutorialSliceState = {
  runTour: false,
  stepIndex: 0,
};

export const TutorialSlice = createSlice({
  name: 'tutorial',
  initialState: INITIAL_STATE,
  reducers: {
    setRunTour: (state, action: PayloadAction<boolean>) => {
      state.runTour = action.payload;
    },

    startTour: (state) => {
      state.stepIndex = 0;
      state.runTour = true;
    },

    setStepIndex: (state, action: PayloadAction<number>) => {
      state.stepIndex = action.payload;
    },
    nextStep: (state) => {
      state.stepIndex += 1;
    },
  },
});

export const { setRunTour, startTour, setStepIndex, nextStep } =
  TutorialSlice.actions;

/**
 * The slice for the tutorial feature
 *
 * @param state the root state
 * @returns     the tutorial state
 */
export const getTutorialState = (state: RootState) => state.tutorial;
